import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/throw';

/*Services */
import { AuthService } from '@services/http/auth.service';
import { CachedDataService } from '@services/data/cached-data.service';

export class BaseHttpService {
  constructor(
    protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService) { }

  send<T>(method: string, uri: string, params?: HttpParams, allowRetry = true, body?): Observable<T> {

    const headers = new HttpHeaders().append('Authorization', `Bearer ${this.cachedDataService.getToken()}`);

    return this.httpClient.request<T>(method, uri, { body: body, headers: headers, params: params }).catch(
      (error: HttpErrorResponse) => {
        if (error.status === 401 && allowRetry) {
          const restoreTokenObservable = new Observable<T>(subscriber => {
            this.tryRestoreToken().subscribe(restoreTokenResult => {
              if (restoreTokenResult) {
                this.send<T>(method, uri, params, false, body).subscribe(data => {
                  subscriber.next(data);
                });
              } else {
                this.router.navigate(['/signin']);
              }
            });
          });
          return restoreTokenObservable;
        }
        if (error.status === 403) {
          this.cachedDataService.clearCache();
          this.router.navigate(['/signin']);
        }
        if (error.status === 407 || error.status === 0) {
          this.authService.needUpdatePasswordSubject.next(true);
        }
        return Observable.throw(error);
      });
  }

  tryRestoreToken(): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      const credentials = this.cachedDataService.getCredentials();

      if (!credentials) {
        this.cachedDataService.clearCache();
        this.router.navigate(['/signin']);
      } else {
        // tslint:disable-next-line:no-non-null-assertion
        if (credentials && (!credentials.username.length || credentials.password.length!)) {
          this.cachedDataService.clearCache();
          this.router.navigate(['/signin']);
        } else {
          this.authService.signIn(credentials.username, credentials.password)
            .then((loginResponse) => {
              this.cachedDataService.setToken(loginResponse.token);
              subscriber.next(true);
            })
            .catch((error: any) => {
              subscriber.next(false);
            });
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/base-http.service.ts